import ParticlesBackground from "./components/ParticlesBackground";
import MainBlock from "./MainBlock";

function App() {
  return (
    <>
    <ParticlesBackground />
    <MainBlock/>
    </>
  )
}

export default App;
